export interface Feature {
	title: string;
	description: string;
	/** Optional path to Lottie animation for the icon */
	lottieSrc?: string;
	/** Or an inline SVG path */
	svgPath?: string;
}

export const features: Feature[] = [
	{
		title: 'Immutable OS',
		description:
			'Ship your entire rootfs as a layered OCI container. One artefact, identical across every device. Drift eliminated by design.',
		lottieSrc: '/animations/Define - Icon.json'
	},
	{
		title: 'Atomic OTA rollouts',
		description:
			'Near-instant agent and workload updates with automatic rollback. Kernel releases roll out as fast as your fleet can reboot.',
		lottieSrc: '/animations/Rollout - Icon.json'
	},
	{
		title: 'Real-time observability',
		description:
			'Live telemetry, logs, and on-demand device screenshots. Debug production from your browser without ever opening an inbound port.',
		lottieSrc: '/animations/Monitor - Icon.json'
	},
	{
		title: 'Quantum-safe zero trust',
		description:
			'Hybrid post-quantum TLS 1.3 with ML-KEM. Hardware-rooted identity, proof-of-possession authentication, and short-lived per-device credentials.',
		svgPath:
			'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z'
	},
	{
		title: 'API-first by default',
		description:
			'Every action in Admiral is available through a comprehensive API, with webhooks for every event. Build your own GitOps pipeline around it.',
		svgPath: 'M10 20l4-16m4 4l-4 4-4 4M6 16l-4-4 4-4'
	},
	{
		title: 'Built for x86 and ARM',
		description:
			'Beefy x86 servers and lightweight ARM64 SoCs run the same image. Reference targets include the Allwinner H618 with full 4K video playback.',
		svgPath: 'M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z'
	}
];
